import { Link, useLocation } from 'react-router-dom';

import { useSession } from '../auth/session';

type LayoutProps = { children: React.ReactNode };

export function Layout({ children }: LayoutProps) {
  const { user, logoutAndRefresh } = useSession();
  const loc = useLocation();

  const loginHref = `/api/auth/login?next=${encodeURIComponent(loc.pathname + loc.search)}`;

  return (
    <div className="shell">
      <header className="topbar">
        <div className="brand">
          <Link to="/">My Cloud Cinema API</Link>
          <span className="muted">Developer documentation</span>
        </div>
        <nav className="nav-actions">
          {user ? (
            <>
              <span className="who" title={user.email || user.sub}>
                {user.name || user.email || user.sub}
              </span>
              <Link className="btn ghost" to="/edit">
                Edit spec
              </Link>
              <button type="button" className="btn ghost" onClick={() => void logoutAndRefresh()}>
                Sign out
              </button>
            </>
          ) : (
            <a className="btn primary" href={loginHref}>
              Sign in to edit
            </a>
          )}
        </nav>
      </header>
      <main className="main">{children}</main>
    </div>
  );
}
